import React, { createContext, useContext, useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { UserRoleContext } from '../../components/Authentication/firebaseAuth/UserRoleContext';
const LogoutContext = createContext();

export const useLogoutContext = () => {
    return useContext(LogoutContext);
};

export const LogoutProvider = ({ children }) => {
    const { setViewFlag } = useContext(UserRoleContext);
    const [userEmail, setUserEmail] = useState("");
    let navigate = useNavigate();
    let path = `${process.env.PUBLIC_URL}/`;
    const { updateUserRole } = useContext(UserRoleContext);
    const signOut = () => {
        setViewFlag(true);
        // Perform your sign-out logic here

        // After successful sign-out, update user role and navigate to the desired route
        updateUserRole('');
        // localStorage.removeItem('metaData');
        // localStorage.removeItem('token');
        localStorage.clear(); // Removes all localStorage data
        sessionStorage.clear();
        navigate(path); // Replace '/login' with your desired sign-out route
        
    };

    const routeChange = () => {
        let path = `${process.env.PUBLIC_URL}/`;
        navigate(path);
    }

    // Define a generic handleResponse function
    const handleResponse = async (response, successCallback) => {
        if (response.ok) {
            const data = await response.json();
            successCallback(data);
        } else {
            switch (response.status) {
                case 401:
                    // Handle unauthorized access
                    break;
                case 404:
                    // Handle not found error
                    break;
                case 403:
                    // Handle not found error
                    signOut();
                    break;
                // Add more cases for other status codes as needed
                default:
                    console.error(`Error: ${response.statusText}`);
                    window.location.href = '../../ErrorPages.jsx';
                    // Handle other unspecified errors
                    break;
            }
        }
    };

    const deleteDatabase = async () => {
        const dbs = await window.indexedDB.databases();
        dbs.forEach((db) => {
          window.indexedDB.deleteDatabase(db.name);
        });
      };
      

      const [metaData, setMetaData] = useState(null);

      const handleAccess = async () => {
        const storedData = localStorage.getItem("metaData");
        if (storedData) {
          setMetaData(JSON.parse(storedData));
        } else {
            let path = `${process.env.PUBLIC_URL}/`;
            // Load default URL if metaData doesn't exist in localStorage
            window.location.href = path;
        }
      };

    return (
        <LogoutContext.Provider value={{
            signOut, handleResponse, deleteDatabase , handleAccess, userEmail, setUserEmail
        }}>
            {children}
        </LogoutContext.Provider>
    );
};
